'use strict';

(function () {

    angular.module('zp').controller('navRibbonController', navRibbonController);

    /**@ngInject */
    function navRibbonController($state, $location, $rootScope, $window) {

        var vm = this;

        vm.isMenuActive = isMenuActive;
        vm.openMenu = openMenu;
        vm.isMobileScreen = function () {
            return $window.innerWidth < 769;
        };

        ////////////////////////////////

        (function () {
            vm.ribbonStyle = $state.current.name.indexOf('nav.main') !== -1 ? { top: '-8px' } : $state.current.name === 'nav.honey-moon' ? { display: 'none' } : { top: '-12px' };
        })();

        ////////////////////////////////

        function isMenuActive(menu) {
            var url = $location.url();
            return url.indexOf(menu) !== -1;
        }

        function openMenu() {
            $rootScope.$emit('OPEN_SIDE_MENU', null);
        }
    }
})(window.angular);